<template>
  <div :class="`${classVariableName}-average-rating-section`">
    <div
      v-if="isMounted && ratingsCount"
      :class="`${classVariableName}-average-rating-section`"
    >
      <span :class="`${classVariableName}-average-rating`">
        {{ avgRating }}
        <div :class="`${classVariableName}-average-rating-total-count`">/5</div>
      </span>
      <Star kind="filled" />
      <span
        @click="moveToReviewSection"
        :class="`${classVariableName}-average-rating-total-reviews ${classVariableName}-cursor-pointer`"
      >
        {{ ratingsCount }} {{ ratingsCount === 1 ? 'Rating' : 'Ratings' }}
      </span>
    </div>
    <div
        v-if="ratingsCount && (!userReviewed || userCurrentReview.tags.includes('RATING_ONLY_REVIEW'))"
    >
        &nbsp;
        <span :class="`${classVariableName}-bullet-separator`"></span>
        &nbsp;
    </div>
    <fdk-accounts v-slot="accountsData" v-if="
      !userReviewed || userCurrentReview.tags.includes('RATING_ONLY_REVIEW')
    ">
      <span
        @click="() =>
          accountsData.is_logged_in
            ? moveToReviewSection()
            : accountsData.openLogin()
        "
        :class="`${classVariableName}-average-rating-total-reviews ${classVariableName}-cursor-pointer`"
      >
        Rate this product
      </span>
    </fdk-accounts>
  </div>
</template>

<script>
import Star from "./components/common/Star.vue";
import { isEmpty, classVariableName, getEventData,
  emitEvent
} from "./utils.js";
import CUSTOM_EVENTS from "./constants.js";
import customerServices from "./services/customer-review.js";

export default {
  name: "AverageRatingComponent",
  components: {
    Star,
  },
  computed: {},
  data() {
    return {
      updated: window.ratingUpdated,
      // review
      avgRating: 0,
      ratingsCount: 0,
      reviewsCount: 0,
      isTIRA: false,
      isBV: false,
      noReviews: false,
      showAlert: null,
      alertMessage: null,
      alertType: "primary",
      userReviewed: false,
      userCurrentReview: null,
      // product
      product: {},
      productId: null,
      alternateCode1: null,
      isMounted: false,
      classVariableName: classVariableName,
    };
  },
  watch: {
    updated(ratingUpdated) {
      if (ratingUpdated) {this.getProductSummary();}
    },
  },
  mounted() {
    window.FPI.state.product.subscribe(this.getProducts.bind(this));
  },
  destroy() {
    window.FPI.state.product.unsubscribe(this.getProducts.bind(this));
  },

  methods: {
    async toast(message, type) {
      this.alertMessage = message;
      this.showAlert = true;
      this.alertType = type;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    },

    async getProductSummary() {
      return await customerServices
        .getProductStats(this.productId)
        .then((data) => {
          let res = data.data;
          if (res.resultInfo.status !== "SUCCESS") {
            this.toast(res.resultInfo.message, "danger");
          } else if (
            res.resultInfo.status === "SUCCESS" &&
            !isEmpty(res.data)
          ) {
            this.avgRating = res.data.averageRating;
            this.ratingsCount = res.data.ratingsCount;
            this.isMounted = true;
            window.ratingUpdated = false;
            let sources = res.data.sources;
            if (!isEmpty(sources) && sources.indexOf("BV")!=-1) {
              this.isBV = true;
            }
            else if (!isEmpty(sources) && (sources.indexOf("PDP")!=-1 || sources.indexOf("TIRA")!=-1)) {
              this.isTIRA = true;
            }
            else if (isEmpty(sources) && isEmpty(this.avgRating)) {
              this.noReviews = true;
            }
          }
          else if (isEmpty(res.data)) {
              this.noReviews = true;
          }
          let extendedProductDetails = { ...this.product, isTIRA: this.isTIRA, isBV: this.isBV, noReviews: this.noReviews, avgRating: this.avgRating };
          emitEvent(CUSTOM_EVENTS.PDP_LOAD, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'PDP', extendedProductDetails, null));
        })
        .catch((error) => console.error(error));
    },

    async getProducts(product) {
      let newProductId = (product.product.attributes && product.product.attributes['group-product-id']) ? Array.isArray(product.product.attributes['group-product-id']) ? product.product.attributes['group-product-id'][0] : product.product.attributes['group-product-id'] : product.product.item_code;
      if (this.productId !== newProductId) {
        this.productId = newProductId;
        this.alternateCode1 = product.product.item_code;
        this.product = {
          ...this.product,
          ...product.product
        };
        this.init();
      }
    },

    init() {
      this.resetInitials();
      this.getProductSummary();
      this.getUserReview();
    },

    resetInitials() {
      this.avgRating= 0,
      this.ratingsCount= 0,
      this.reviewsCount= 0,
      this.showAlert= null,
      this.alertMessage= null,
      this.alertType= "primary",
      this.userReviewed= false,
      this.userCurrentReview= null
    },
    async getUserReview() {
      let query = {
        productId : this.productId, 
        alternateCode1 : this.alternateCode1
      };
      return await customerServices
        .getProductVariantReviewOfUser(query)
        .then(async (data) => {
          let res = data.data;
          if (res.resultInfo.status === "SUCCESS") {
            if (!isEmpty(res.data)) {
              var isPendingReview = await this.checkIfReviewInPendingState(
                res.data
              );
              if (isPendingReview) this.userCurrentReview = res.data["PENDING"];
              else this.userCurrentReview = res.data["APPROVED"];
              this.userReviewed = true;
            }
          }
      });
    },

    async checkIfReviewInPendingState(reviewMap) {
      return !isEmpty(reviewMap["PENDING"]);
    },

    async moveToReviewSection() {
      var reviewSection = document.getElementById("central-rnr-widget-review-listing");

      // Adjust scroll position to be 8% from the top of the visible display
      const windowHeight = window.innerHeight;
      const scrollToPosition = reviewSection.getBoundingClientRect().top + window.scrollY - (windowHeight * 0.2);
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/Avg.scss";
</style>
